var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copy-cell-renderer"},[_c('div',{attrs:{"id":_vm.id}},[_vm._t("default")],2),_c('BTooltip',{attrs:{"target":_vm.id}},[_c('CopyBtn',{attrs:{"text":_vm.text}},[_vm._v(_vm._s(_vm.$t('common.copy')))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }